// Phase 6 — Track E T-E3. Badge primitive (shadcn-derived).
//
// Used for small inline status / counts. Variants map to priority +
// state tokens. Default is `neutral` — surface-raised wash with
// border-default; loud variants (success / warning / danger) rely on
// the corresponding state tokens.

import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/cn.js';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-micro font-medium transition-colors',
  {
    variants: {
      variant: {
        neutral:
          'border-border-default bg-surface-raised text-text-secondary',
        accent:
          'border-transparent bg-accent-subtle text-accent-default',
        success:
          'border-transparent bg-state-success text-text-on-accent',
        warning:
          'border-transparent bg-state-warning text-text-on-accent',
        danger:
          'border-transparent bg-state-danger text-text-on-accent',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
